import { createAction, props } from '@ngrx/store';

import { BAC_ACTION_PREFIX } from '../constants';

export const setFeatureFlagsAction = createAction(
  `${BAC_ACTION_PREFIX} Set Feature Flag`,
  props<{ featureFlagId: string; isEnabled: boolean }>()
);

export const getFeatureFlagsAction = createAction(
  `${BAC_ACTION_PREFIX} Get Feature Flags`
);
